import React from 'react'
import { Link } from 'gatsby'
import { useSelector } from '~/store/hooks'

import trads from '~/intl/trads.json'

import LinkIcon from '~/components/core/linkIcon'
import Image from '~/components/core/Image'
import transformLink from '~/utils/transformLink'

const PushContent = ({ data, type, autoItems, noTitle = false }) => {
  // redux lang
  const lang = useSelector((state) => state.lang)

  let pushs = data

  if (!data && !!autoItems) {
    pushs = autoItems.nodes ? autoItems.nodes : autoItems
  }

  return (
    <>
      {pushs?.length > 0 && (
        <div className={`push-content push-content--${type}`}>
          <div className="fluid-grid">
            <div className="row">
              <div className="col-12 lg-col-10 xl-col-8 mx-auto relative z-1">
                {type === 'inner' && !noTitle && (
                  <h2 className="text-label text-label--big text-label--bg bg-blue text-white mb-8">
                    {trads[lang].readAlso}
                  </h2>
                )}
                <div className="md:flex push-content__cards">
                  {pushs.map((item, i) => {
                    let datas, page, url, title, contentType
                    let chapo = null
                    let ctaLabel = null
                    let mainImage = null

                    if (data !== null && data !== undefined) {
                      datas = item.fields ? item.fields : item
                      page = item.fields ? datas.page.fields : datas.page

                      let cta = transformLink(datas.page, false, false)
                      url = cta.url
                      contentType = cta.contentTypeContentful

                      if (datas.chapo) {
                        chapo = datas.chapo.chapo
                          ? datas.chapo.chapo
                          : datas.chapo
                      }
                      title = page.title

                      if (
                        page.mainImage ||
                        (page.fields && page.fields.mainImage)
                      ) {
                        mainImage = page.fields
                          ? page.fields.mainImage
                          : page.mainImage
                      }

                      if (datas.ctaLabel) {
                        ctaLabel = datas.ctaLabel
                      }
                    } else {
                      title = item.fields ? item.fields.title : item.title
                      let cta = transformLink(item, false, false)
                      url = cta.url
                      contentType = cta.contentTypeContentful

                      item = item.field ? item.fields : item

                      if (
                        item.mainImage ||
                        (item.fields && item.fields.mainImage)
                      ) {
                        mainImage = item.fields
                          ? item.fields.mainImage
                          : item.mainImage
                      }

                      ctaLabel = trads[lang].learnMore
                    }

                    return (
                      <React.Fragment key={i}>
                        {contentType === 'ContentfulSimulator' ||
                        contentType === 'ContentfulContact' ? (
                          <a
                            href={url}
                            className="push-content-card"
                            aria-label={ctaLabel}
                          >
                            <Inner
                              mainImage={mainImage}
                              ctaLabel={ctaLabel}
                              title={title}
                              chapo={chapo}
                              defaultLabel={trads[lang].learnMore}
                            />
                          </a>
                        ) : (
                          <Link
                            to={url}
                            className="push-content-card"
                            aria-label={ctaLabel}
                          >
                            <Inner
                              mainImage={mainImage}
                              ctaLabel={ctaLabel}
                              title={title}
                              chapo={chapo}
                              defaultLabel={trads[lang].learnMore}
                            />
                          </Link>
                        )}
                      </React.Fragment>
                    )
                  })}
                </div>
                <img
                  src="/img/more.svg"
                  className="push-content__deco"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const Inner = ({ mainImage, title, chapo, ctaLabel, defaultLabel }) => {
  return (
    <>
      <div className="push-content-card__img-wrap">
        {mainImage ? (
          <div className="push-content-card__img">
            <Image
              width="430"
              height="260"
              sizes={{ 415: [354, 215], 767: [767, 670], 1023: [700, 430] }}
              isBg={true}
              image={mainImage}
            />
          </div>
        ) : (
          <div className="push-content-card__img push-content-card__img--empty"></div>
        )}
      </div>
      <div className="push-content-card__content">
        <p className="title-3-bold mb-2">{title}</p>

        <p className="push-content-card__txt">{chapo}</p>

        <LinkIcon text={ctaLabel ? ctaLabel : defaultLabel} />
      </div>
    </>
  )
}

export default PushContent
